import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT,
    ADDNOTIFICATION,
    ADD,
    RESETNOTIFICATION,
    SETSPIN
} from './types';

import {
    AddNewType,
    AddNew
} from 'one-model-local'

/**
 * Redux action creator to open 
 * add new form
 * @param addnewtype contains boolean value either true/false
 * @returns action instance
 */
export const setAction = (addnewtype: AddNewType):
    Action<typeof SET, AddNewType> => ({
        type: SET,
        payload: addnewtype,
    });

/**
 * Redux action creator to set Notification
 * for Add New Form
 * @param addnewtype contains notification value and message
 * @returns action instance
 */
export const setNotification = (addnewtype: AddNewType):
    Action<typeof ADDNOTIFICATION, AddNewType> => ({
        type: ADDNOTIFICATION,
        payload: addnewtype,
    });    

/**
 * Redux action creator to set Spin
 * for Add New Form
 * @param addnewtype contains Spin value
 * @returns action instance
 */
export const setSpin = (addnewtype: AddNewType):
    Action<typeof SETSPIN, AddNewType> => ({
        type: SETSPIN,
        payload: addnewtype,
    });       

/**
 * Redux action creator to reset Notification
 * for Add New Form
 * @param addnewtype contains reset notification value and message
 * @returns action instance
 */
export const resetNotification = (addnewtype: AddNewType):
    Action<typeof RESETNOTIFICATION, AddNewType> => ({
        type: RESETNOTIFICATION,
        payload: addnewtype,
    }); 
    
    
/**
 * Redux action creator to add
 * new form
 * @param addnew contains AddNew Object
 * @returns action instance
 */
export const addAction = (addnew: AddNew):
    Action<typeof ADD, AddNew> => ({
        type: ADD,
        payload: addnew,
    });

/**
 * Re-initialize the state
 * @returns action instance 
 */
export const reinitAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });


/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof addAction> |
    ReturnType<typeof setNotification> |
    ReturnType<typeof resetNotification> |
    ReturnType<typeof setSpin> |
    ReturnType<typeof reinitAction>;

